<template>
    <!-- 页未 -->
    <div class="footer">
        <!--v-if="hash!='/contactUs'"-->
        <div class="footContent">
            <el-row style="color:#939393">
                <el-col :xs="24" :sm="12" style="text-align: center">
                    <el-row class="hidden-xs-only">
                        <el-col :xs="24" :sm="6">
                            <h3 style="margin-bottom: 10px">客户服务</h3>
                            <ul>常见问题解答</ul>
                            <ul>取消订阅</ul>
                            <ul>联系人</ul>
                        </el-col>
                        <el-col :xs="24" :sm="6">
                            <h3 style="margin-bottom: 10px">关于</h3>
                            <ul>逐日科技</ul>
                            <ul>巴藤校园</ul>
                            <ul>功夫极客</ul>
                        </el-col>
                        <el-col :xs="24" :sm="6">
                            <h3 style="margin-bottom: 10px">法律</h3>
                            <ul>隐私政策</ul>
                            <ul>浏览器缓存政策</ul>
                            <ul>条款与条件</ul>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :xs="24" :sm="12" style="text-align: center;">
                    <div class="hidden-xs-only">
                        <img style="width: 130px;height:42px" src="../../../static/image/logo.png"/>
                    </div>
                    <ul>Copyright◎ 2017-2021</ul>
                    <ul>www.zhuritec.com</ul>
                    <ul>苏ICP备17018315号-3</ul>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    props: {
        hash: String
    },
    data() {
        return {
            isShow: true
        }
    },
    methods: {
        goContactPage() {
            this.$router.push({path: '/contactUs'});
            window.scrollTo(0, 0);
        }
    }
}
</script>

<style lang="less">
.footer {
    background-color: #2B2A2A;
    width: 100%;
    box-sizing: border-box;
    padding: 40px 0 60px 0;
 
    // position: absolute;
    // bottom: 0;
    .middle {
        width: 100%;
        margin: 0 auto;
    }
}

.contact {
    width: 100%;
    background: #2B2A2A;

    a {
        display: inline-block;
        padding: 0 100px;
        height: 50px;
        line-height: 50px;
        border-radius: 50px;
        text-align: center;
        font-size: 22px;
        color: #939393;
        text-decoration: none;
    }
}

.bottom {
    background: #f7fbfd;
    text-align: center;
    color: #ababab;
    height: 72px;
    padding-top: 32px;
}

.footContent {
    width: 1170px;
    margin: 0 auto;
}

@media (max-width: 768px) {
    .footContent {
        width: 90%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue